export const getAction = (enabled?: boolean, cloud = false): string =>
  enabled ? (cloud ? 'Disable for maintenance' : 'Disable') : 'Enable'
export const getStatus = (enabled?: boolean, cloud = false): string =>
  enabled ? 'enabled' : cloud ? 'disabled for maintenance' : 'disabled'
export const getTitle = (enabled: boolean | undefined, togglable: boolean, cloud = false): string =>
  [
    `Agent is ${getStatus(enabled, cloud)}`,
    togglable && `, click to ${getAction(enabled, cloud).toLowerCase()}`,
    '.',
  ]
    .filter(Boolean)
    .join('')
